module.exports = __webpack_public_path__ + "img/Refused.a0580545.png";